import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';

const renderApp = () => {
  ReactDOM.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
    document.getElementById('root')
  );
};

const restoreHistoryMethods = () => {
  // Restore history.replaceState and history.pushState
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  // eslint-disable-next-line no-underscore-dangle
  window.history.replaceState = window._historyReplaceState;
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  // eslint-disable-next-line no-underscore-dangle
  window.history.pushState = window._historyPushState;
};

if (window.Office) {
  new Promise((resolve) => {
    const timeout = window.setTimeout(() => {
      resolve(false);
    }, 1000);

    window.Office.onReady()
      .then(() => {
        clearTimeout(timeout);
        resolve(true);
      })
      .catch(() => {
        clearTimeout(timeout);
        resolve(false);
      });
  }).then(() => {
    restoreHistoryMethods();
    renderApp();
  });
} else {
  renderApp();
}

reportWebVitals();
